const BASE_URL = process.env.REACT_APP_BOT_BASE_URL;

export const randomGoBackMessage = () => {
  const list = ['Ok, vou repetir a última pergunta.'];
  return list[Math.floor(Math.random() * list.length)];
};

export const sendActiveCampaign = (payload) => {
  if (process.env.NODE_ENV !== 'development') {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const response = {
      activecampaign: true,
      ...payload,
    };
    fetch(`${BASE_URL}/connect/integration`, {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(response),
    });
  }
};
